import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'

const API_PREFIX = '/game/fast-game/3-kings-scratch'
const config = { server: microServices.SERVICE_URL_1 }

const request = (method, endpoint, data = {}, extra = {}) =>
  axiosInstanceService(method, `${API_PREFIX}/${endpoint}`, data, {
    ...config,
    ...extra
  })

export const placeBetThreeKingsService = ({ data, isDemoGame }) =>
  request(METHOD_TYPES.post, 'place-bet', data, {
    headers: { 'demo-game': isDemoGame },
    loader: LOADER_HANDLER_TYPES.submit
  })

export const getMyBetsThreeKingsService = (params) =>
  request(METHOD_TYPES.get, 'my-bets', {}, { params })

export const getTopWinsThreeKingsService = (params) =>
  request(METHOD_TYPES.get, 'get-top-win', {}, { params })

export const checkFairnessThreeKingsService = (data) =>
  request(METHOD_TYPES.post, 'check-fairness', data)
